import styled from 'styled-components';
import Box from '@quintoandar/cozy-core/Box';
import CircularProgress from '@quintoandar/cozy-core/CircularProgress';
import { MOBILE_MAX_SCREEN_SIZE } from 'constants/screen';

export const LoadingWrapper = styled(Box)`
    align-items: center;
    max-width: 228px;

    @media(max-width: ${MOBILE_MAX_SCREEN_SIZE}px) {
        max-width: 100%;
    }
`;

export const Loading = styled(CircularProgress)`
    position: absolute;
`;
